import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calculatePermille } from "../slices/alcoholSlice";

export default function useRefreshPermille() {
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.user);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(calculatePermille({ user: userData }));
    }, 3000);
    return () => clearInterval(interval);
  }, [dispatch, userData]);
}
